import { useRef, useState } from 'react'
import { Box, InputBase, Menu, MenuItem, Select } from '@mui/material'
import { t } from 'i18next'

import ButtonPrimary from 'src/components/shared/ui/ButtonPrimary'
import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import { AngleDownIcon2, FilterIcon } from 'src/components/shared/ui/Icons'
import { fieldsStyles } from 'src/components/shared/ui/form/fields/fieldsStyles'
import { theme } from 'src/providers/ThemeProvider'

import { filterColumnHeaderStyles as styles, useStyles } from './FilterColumnHeaderStyles'

type Props = {
  column: any
}

export enum FilterType {
  CONTAINS = 0,
  START_WITH = 1
}

export type Filter = {
  type: FilterType
  query: string
}

const initFilter: Filter = {
  type: FilterType.CONTAINS,
  query: ''
}

function FilterColumnHeader({ column: { setFilter, id } }: Props): JSX.Element {
  const [active, setActive] = useState(false)
  const [openFilters, setOpenFilters] = useState(false)
  const [currentFilter, setCurrentFilter] = useState<Filter>(initFilter)

  const classes = useStyles()

  const anchorEl = useRef<HTMLDivElement>(null)

  function onOpenMenu(ev) {
    ev.preventDefault()
    ev.stopPropagation()
    setOpenFilters(true)
  }

  function onCloseMenu(ev) {
    ev.preventDefault()
    ev.stopPropagation()
    setOpenFilters(false)
  }

  function cleanFilters() {
    setCurrentFilter(initFilter)
    setActive(false)
    setFilter(initFilter)
  }

  function applyFilters() {
    setActive(currentFilter.query.trim().length > 0)
    setFilter(currentFilter)
    setOpenFilters(false)
  }

  function onChangeType(e: any) {
    const { value } = e.target
    setCurrentFilter({ ...currentFilter, type: value })
  }

  function onChangeQuery(e: any) {
    const { value } = e.target
    setCurrentFilter({ ...currentFilter, query: value })
  }

  return (
    <>
      <Box ref={anchorEl} onClick={onOpenMenu}>
        <FilterIcon
          htmlColor={active ? theme.corporate.primaryColor : theme.colors.gray600}
          sx={styles.iconFilter}
        />
      </Box>

      <Menu
        id={`filter_${id}`}
        anchorEl={anchorEl.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        open={openFilters}
        sx={styles.filtersMenu}
        onClose={onCloseMenu}
      >
        <Box
          onClick={ev => {
            ev.preventDefault()
            ev.stopPropagation()
          }}
        >
          <Select
            labelId="select-user-profile-label"
            id="select-user-profile"
            value={currentFilter.type}
            onChange={onChangeType}
            sx={styles.selectType}
            variant="outlined"
            MenuProps={{
              PaperProps: {
                className: classes.popper
              }
            }}
            IconComponent={_props => (
              <Box className="wrapperIcon">
                <AngleDownIcon2 className={_props.className.toString()} />
              </Box>
            )}
          >
            <MenuItem value={FilterType.CONTAINS} sx={styles.option}>
              Contiene
            </MenuItem>
            <MenuItem value={FilterType.START_WITH} sx={styles.option}>
              Empieza por
            </MenuItem>
          </Select>

          <Box sx={styles.input}>
            <InputBase
              sx={fieldsStyles.input}
              value={currentFilter.query}
              onChange={onChangeQuery}
            />
          </Box>

          <Box display="flex" flexDirection="row" sx={styles.wrapperActions}>
            <ButtonPrimaryOutlined onClick={cleanFilters}>
              {t('actions.clean')}
            </ButtonPrimaryOutlined>
            <ButtonPrimary onClick={applyFilters}>{t('actions.filter')}</ButtonPrimary>
          </Box>
        </Box>
      </Menu>
    </>
  )
}

export default FilterColumnHeader
